import axios from "axios";
import { SERVICEURL } from "../appconfig";

export interface GetEmailDetailResponse {
  emailId: string;
  emailName: string;
  communicationParameterId?: string;
}

export interface UpdateEmailPayload {
  emailId: string;
  emailName: string;
  communicationParameterId?: string;
}

export const getEmailDetail = async (
  id: string
): Promise<GetEmailDetailResponse> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${SERVICEURL}api/Candidates/GetEmailDetail/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const rawData = response.data?.data || response.data;

  const findField = (obj: any, fieldName: string) => {
    const key = Object.keys(obj).find(
      (k) => k.toLowerCase() === fieldName.toLowerCase()
    );
    return key ? obj[key] : undefined;
  };

  return {
    emailId: String(findField(rawData, "emailid") ?? ""),
    emailName: findField(rawData, "emailname") ?? "",
    communicationParameterId: findField(rawData, "communicationparameterid")
      ? String(findField(rawData, "communicationparameterid"))
      : undefined,
  };
};

export const updateEmailInfo = async (
  payload: UpdateEmailPayload
): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.put(`${SERVICEURL}api/Candidates/UpdateEmailInfo`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteEmailInfo = async (emailId: string): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(`${SERVICEURL}api/Candidates/DeleteEmailInfo/${emailId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
